/**
 * The navigation keys this vertical owns.
 *
 * Three, and only three: the screens no other profile grants and that the
 * nav registry gates `only: ['SYCEBNL']`. The rest of what the profile lists
 * is core (`CORE_MODULES`) or capability-pack vocabulary that happens to be
 * granted here too — shared keys, not this module's.
 */
export const ASSOCIATION_KEYS = [
    "accounting-etats-sycebnl",
    "accounting-donor-register",
    "accounting-funds",
];
//# sourceMappingURL=keys.js.map